import isFunction from 'lodash/isFunction'
import isNil from 'lodash/isNil'
import React, { useEffect, useState } from 'react'
import TextField from 'ui/molecules/TextField'

import Ui from '../../ui'
import { schemasValidate } from '../../utils/schemas'
import OpacityBg from '../OpacityBg'

const initialFormError = { input: false }
const initialFormErrorLabel = { input: undefined }
// TODO: deprecate and kill this component

function ModalPrompt({
  isVisible,
  title,
  description,
  inputType,
  inputLabel,
  inputPlaceholder,
  initialInput,
  inputScheme,
  submitTitle,
  onSubmit,
  loading,
  canDismiss,
  onClose,
  hideCross,
  closeButton,
  closeButtonText,
}) {
  const [input, setInput] = useState(initialInput || '')
  const [formError, setFormError] = useState(initialFormError)
  const [formErrorLabel, setFormErrorLabel] = useState(initialFormErrorLabel)

  useEffect(() => {
    formError?.input === true && validateInput()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input])

  async function validateInput(): boolean {
    if (isNil(inputScheme)) return true
    return await await schemasValidate(
      [['input', input, inputScheme]],
      setFormError,
      setFormErrorLabel
    )
  }

  async function onPressButton() {
    const isValid = await validateInput()
    if (!isValid) return false
    isFunction(onSubmit) && onSubmit(input)
  }

  return (
    isVisible && (
      <OpacityBg onClick={canDismiss ? onClose : () => {}}>
        <div
          className="relative mx-3 max-w-sm flex-1 space-y-4 rounded bg-white px-4 py-4"
          onClick={(e) => e.stopPropagation()}
        >
          {!hideCross && (
            <Ui.ButtonIconClose
              className="absolute right-0 top-0 mr-3 mt-3"
              onClick={onClose}
            />
          )}
          {title && (
            <h4 className="text-lg font-medium text-txt-emphasis">{title}</h4>
          )}
          {description && <p className="text-sm text-txt">{description}</p>}
          <div>
            {inputType === 'phone' ? (
              <Ui.SingleLinePhone
                errorLabel={formErrorLabel?.input}
                hasError={formError?.input}
                label={inputLabel}
                name="input"
                onBlur={validateInput}
                onChange={setInput}
                placeholder={inputPlaceholder}
                type={inputType}
                value={input}
              />
            ) : (
              <TextField
                errorLabel={formErrorLabel?.input}
                hasError={formError?.input}
                label={inputLabel}
                name="input"
                onBlur={validateInput}
                onChange={setInput}
                placeholder={inputPlaceholder}
                type={inputType || 'email'}
                value={input}
              />
            )}
          </div>
          <div className="flex flex-row justify-between justify-items-center">
            {closeButton && (
              <div className="flex flex-col">
                <Ui.ButtonClear className="border" onClick={onClose}>
                  {closeButtonText || 'Cancel'}
                </Ui.ButtonClear>
              </div>
            )}
            <div className="flex w-full flex-col items-center">
              <Ui.PrimaryButton loading={loading} onClick={onPressButton}>
                {submitTitle || ''}
              </Ui.PrimaryButton>
            </div>
          </div>
        </div>
      </OpacityBg>
    )
  )
}

export default ModalPrompt
